import { render } from "./BomImagePopover.vue?vue&type=template&id=58ef6fc1"
import script from "./BomImagePopover.vue?vue&type=script&lang=js"
export * from "./BomImagePopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__